// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  adviceId: __t.u64().primaryKey().name("advice_id"),
  civ: __t.string(),
  cyc: __t.u64(),
  operation: __t.string(),
  source: __t.string(),
  say: __t.string(),
  at: __t.timestamp(),
});
